export const stateNameToFips = {
  "Alabama": "01", "Alaska": "02", "Arizona": "04", "Arkansas": "05",
  "California": "06", "Colorado": "08", "Connecticut": "09", "Delaware": "10",
  "District of Columbia": "11", "Florida": "12", "Georgia": "13", 
  "Hawaii": "15", "Idaho": "16", "Illinois": "17", "Indiana": "18",
  "Iowa": "19", "Kansas": "20", "Kentucky": "21", "Louisiana": "22",
  "Maine": "23", "Maryland": "24", "Massachusetts": "25", "Michigan": "26",
  "Minnesota": "27", "Mississippi": "28", "Missouri": "29", "Montana": "30",
  "Nebraska": "31", "Nevada": "32", "New Hampshire": "33", "New Jersey": "34",
  "New Mexico": "35", "New York": "36", "North Carolina": "37", "North Dakota": "38",
  "Ohio": "39", "Oklahoma": "40", "Oregon": "41", "Pennsylvania": "42",
  "Rhode Island": "44", "South Carolina": "45", "South Dakota": "46",
  "Tennessee": "47", "Texas": "48", "Utah": "49", "Vermont": "50",
  "Virginia": "51", "Washington": "53", "West Virginia": "54",
  "Wisconsin": "55", "Wyoming": "56"
};

export const fipsToStateName = Object.entries(stateNameToFips).reduce((acc, [name, fips]) => {
  acc[fips] = name;
  return acc;
}, {});

export const processedCountiesCache = {};

export const countyNameToFips = {
  // South Dakota counties
  "Todd": { "46": "121" },
  "Jackson": { "46": "071" },
  "Mellette": { "46": "095" },
  "Ziebach": { "46": "137" },
  "Bennett": { "46": "007" },
  "Oglala Lakota": { "46": "102" },
  "Dewey": { "46": "041" },
  "Buffalo": { "46": "017" },
  "Corson": { "46": "031" },

  // Mississippi counties
  "Jefferson": { "28": "063" },
  "Leflore": { "28": "083" },
  // ... keep other county entries ...
};

export const cleanCountyName = (name) => {
  if (!name) return '';
  return name.replace(/ Parish| County| city| Census Area| Borough/gi, '').trim();
};

export const getStateCodeFromGeo = (geo) => {
  if (geo.properties?.STATEFP) return geo.properties.STATEFP;
  if (geo.properties?.STATE) return geo.properties.STATE;
  if (geo.properties?.state) return geo.properties.state;
  return null;
};

export const getCountyNameFromGeo = (geo) => {
  if (geo.properties?.NAME) return geo.properties.NAME;
  if (geo.properties?.name) return geo.properties.name;
  if (geo.properties?.county) return geo.properties.county;
  return null;
};

export const getCountyFipsFromGeo = (geo) => {
  if (geo.properties?.COUNTYFP) return geo.properties.COUNTYFP;
  if (geo.properties?.COUNTY) return geo.properties.COUNTY;
  if (geo.properties?.county_fips) return geo.properties.county_fips;
  return null;
};

export const getFipsFromGeo = (geo) => {
  if (geo.id) return geo.id.padStart(5, '0');
  
  const stateFips = geo.properties?.STATEFP?.padStart(2, '0') || '00';
  const countyFips = geo.properties?.COUNTYFP?.padStart(3, '0') || '000';
  return `${stateFips}${countyFips}`;
};

export const getCountyData = (geo, data) => {
  const stateCode = getStateCodeFromGeo(geo);
  const countyName = getCountyNameFromGeo(geo);
  
  if (!stateCode || !countyName || !data) return null;
  
  const countyId = `${stateCode}-${countyName}`;
  
  if (processedCountiesCache[countyId]) {
    return processedCountiesCache[countyId];
  }
  
  const countyData = data.find(item => 
    (item.countyName === countyName) ||
    (item.countyName.toLowerCase() === countyName.toLowerCase())
  );
  
  if (countyData) {
    console.log(`Found match for ${countyName}, State: ${fipsToStateName[stateCode] || stateCode}`);
    processedCountiesCache[countyId] = countyData;
    return countyData;
  }
  
  processedCountiesCache[countyId] = null;
  return null;
}; 